import type { IntlShape } from 'react-intl';

import { productCardMessages } from './messages';

export const getProductCardImageAlt = ({
  collectionName,
  formatMessage,
  isLinkToCollection = false,
  name,
  sku,
}: {
  collectionName?: string | null;
  formatMessage: IntlShape['formatMessage'];
  isLinkToCollection?: boolean;
  name?: string | null;
  sku?: string | null;
}) => {
  let alt = '';
  if (name && sku) {
    alt = `${formatMessage(productCardMessages.productNameAndSku, {
      name,
      sku,
    })} `;
  }

  if (isLinkToCollection && collectionName) {
    alt += `${formatMessage(productCardMessages.linkToPlp, {
      collection: collectionName,
    })}`;
  } else {
    alt += `${formatMessage(productCardMessages.linkToPdp)}`;
  }

  return alt;
};
